class SectionProduct {
  constructor(imageEl) {
    this.imageEl = imageEl;
    this.headerEl = document.querySelector('.js-header-group');
    this.handleResize = this.handleResize.bind(this);
    this.init();
    this.bindEvents();
  }

  init() {
    this.updateStickyOffset();
  }

  bindEvents() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('font-size-updated', this.handleResize);
  }

  handleResize() {
    this.updateStickyOffset();
  }

  updateStickyOffset() {
    if (!this.headerEl || !this.imageEl) return;
    const headerHeight = this.headerEl.offsetHeight;
    // this.imageEl.style.position = 'sticky';
    this.imageEl.style.top = `${headerHeight}px`;
    // this.imageEl.style.zIndex = '10';
  }
}

function initSectionProductSticky() {
  document.querySelectorAll('.js-product-image').forEach((el) => {
    new SectionProduct(el);
  });
}

window.addEventListener('DOMContentLoaded', initSectionProductSticky);
window.addEventListener('font-size-updated', initSectionProductSticky);
